import React, { useEffect, useState, useLayoutEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import PSignupForm from "../PSignupForm";
import PCreditCardForm from "../PCreditCardForm";
import PrivaLogo from "../../images/logos/logo-12.png";
import PLoginForm from "../PLoginForm";
import PReverifyForm from "../PReverifyForm";
import PThankYou from "../PThankYou";
import { useToasts } from "react-toast-notifications";
import Button from "react-bootstrap/Button";
import { LazyLoadImage } from "react-lazy-load-image-component";

import {
    CARD_ERRORS,
    FOLLOW_STATUS,
    FOLLOW_TIER,
    NUT_THEME_USERS,
    RECAPTCHA_SITE_KEY,
    s3Link,
} from "../../utils/constants";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import "./style.scss";
import Avatar from "../Avatar";
import PAlert from "../PAlert";
import currency from "currency.js";
import { useDispatch } from "react-redux";
import {
    fetchPosts,
    setAlert,
    setCreditCardForm,
    setProcessingFollow,
    updateCcVerification,
} from "../../../redux/actions";
import {
    inFreeTiers,
    isLogin,
    notExpired,
    postTypeNeedsSubscription,
} from "../../utils/helper";
import { captureException } from "@sentry/react";
import CloseButton from "../CloseButton";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import PaidSubscriptionOffer from "../PaidSubscriptionOffer";
import axios from "axios";
import { setPostThankyou } from "../../../redux/actions/post";
import useDidMountEffect from "../../utils/useDidMountEffect";

const RenewalDetails = ({ user }) => {
    const [showDetails, setShowDetails] = useState(false);

    const toggleShowDetails = () => {
        setShowDetails(!showDetails);
    };

    return (
        <div className="renewal-details">
            <div className="renewal-details__title">
                This subscription renews at{" "}
                {currency(user.creator.subscription_price).format({
                    precision: 2,
                })}
                .{" "}
                {!showDetails && (
                    <span className="toggle-btn" onClick={toggleShowDetails}>
                        Renewal Info
                    </span>
                )}
            </div>
            {showDetails && (
                <div className="renewal-details__body">
                    <span className="renewal-details__header">
                        Renewal Info:
                    </span>
                    <ul>
                        <li>
                            Your subscription will renew at{" "}
                            {currency(user.creator.subscription_price).format({
                                precision: 2,
                            })}{" "}
                            until you choose to cancel your subscription.
                        </li>
                        <li>
                            If you cancel your subscription you will still have
                            access until it expires.
                        </li>
                        <li>
                            Subject to our{" "}
                            <a href="/terms" target="_blank">
                                Terms
                            </a>
                        </li>
                    </ul>
                    <div className="d-flex">
                        <span
                            className="toggle-btn"
                            onClick={toggleShowDetails}
                        >
                            Hide Renewal Info
                        </span>
                    </div>
                </div>
            )}
        </div>
    );
};

/**
 * getUserInformation function is found at Profile/index.js
 * @param {*} param0
 * @returns
 */
const PSignupModal = ({
    showModal,
    setShowModal,
    user,
    type,
    getUserInformation,
    setFollowStatus,
    showCreditCardForm,
    discountData = null,
    isFree = false,
    posts,
    triggerFollow = false,

    selectedPostGallery,
}) => {
    const dispatch = useDispatch();
    const history = useHistory();

    const { addToast } = useToasts();
    const [isLoading, setIsLoading] = useState(false);
    const [show, setShow] = useState(type);
    const [paymentSuccessful, setPaymentSuccessful] = useState(false);
    const [signupFormStatus, setSignupFormStatus] = useState(false);
    const [showThankYou, setShowThankYou] = useState(false);
    const [fees, setFees] = useState({});
    const [promoUrl, setPromoUrl] = useState({});
    const [freeSubscription, setFreeSubscription] = useState(false);
    const [showPaid, setShowPaid] = useState(false);
    const [title, setTitle] = useState("Transaction Status");
    const [redirectUrl, setRedirectUrl] = useState("");

    const handlePaymentShow = () => {
        dispatch(
            setCreditCardForm({
                show: true,
                prefilled: true,
                closeOnly: true,
                intent: "follow",
                username: user.login,
                mode: "add",
            })
        );
    };

    const [thankyou, setThankyou] = useState(false);
    const handleThankyou = () => setThankyou(!thankyou);

    const isLoggedIn = localStorage.getItem("loggedin_user");

    const [hasExistingCard, setHasExistingCard] = useState(false);
    const [last4, setLast4] = useState("");
    const [isCheckingCard, setIsCheckingCard] = useState(false);
    const [isThemeBlk, setIsThemeBlk] = useState(false);
    const [cardAdded, setCardAdded] = useState(false);
    const [reverifyData, setReverifyData] = useState(null);
    const [isTrialOrFree, setIsTrialOrFree] = useState(false);
    const [isTrialLink, setIsTrialLink] = useState(false);

    useDidMountEffect(() => {
        if (triggerFollow) {
            processPayment(true);
        }
    }, [triggerFollow]);

    useEffect(() => {
        // Promo Code URL
        let promoUrlDetails = null;
        if (!discountData) {
            promoUrlDetails = JSON.parse(localStorage.getItem("promo_url"));
            if (promoUrlDetails && promoUrlDetails.user.id === user.id) {
                // promo code here
                setPromoUrl(promoUrlDetails);
            }
        }

        if (isLogin() && promoUrlDetails && !promoUrlDetails.is_free_link) {
            checkFees(promoUrlDetails);
        }

        checkUserHasCard();

        setIsThemeBlk(NUT_THEME_USERS.includes(user.id));
    }, []);

    useEffect(() => {
        if (signupFormStatus) {
            setShow("follow");
            checkFees();
        }
    }, [signupFormStatus]);

    useEffect(() => {
        if (paymentSuccessful) {
            setShowThankYou(true);
        }
    }, [paymentSuccessful]);

    useEffect(() => {
        const freeSubscriptionEnabled =
            user &&
            user.creator &&
            Object.keys(user.creator).length > 0 &&
            user.creator.free_subscription;
        const isFreeTrialLink =
            promoUrl &&
            promoUrl.hasOwnProperty("is_free_link") &&
            promoUrl.is_free_link;

        setIsTrialLink(isFreeTrialLink);

        if (user && user.creator && Object.keys(user.creator).length > 0) {
            setFreeSubscription(user.creator.free_subscription);
        }

        if (
            (freeSubscriptionEnabled || isFreeTrialLink) &&
            !notExpired(user.subscription_status)
        ) {
            setIsTrialOrFree(true);
        } else {
            setIsTrialOrFree(false);
        }
    }, [user, promoUrl]);

    const checkFees = async (promo) => {
        if (!promoUrl.is_free_link) {
            let payload = {
                pu: user.id,
            };

            if (promo && Object.keys(promo).length > 0) {
                payload.link = promo.link;
            }
            await axios
                .get(`/api/transactions/fees`, {
                    params: payload,
                })
                .then((response) => {
                    setFees(response.data);
                });
        } else {
            setFees({
                reg_gst: 0,
                fees: 0,
                gst: 0,
            });
        }
    };

    const handleClose = () => {
        setShowModal(false);
    };

    const handleFollow = async (e, bySubscription = false) => {
        e.preventDefault();
        const followBySubscription =
            bySubscription ||
            (notExpired(user.subscription_status) &&
                inFreeTiers(user.follow_tier));
        if (freeSubscription && !followBySubscription) {
            processPayment();
        } else {
            setIsLoading(true);
            await axios
                .get("/api/transactions/check")
                .then((response) => {
                    if (
                        response.data.check ||
                        (promoUrl &&
                            promoUrl.hasOwnProperty("is_free_link") &&
                            promoUrl.is_free_link)
                    ) {
                        processPayment(followBySubscription);
                    } else {
                        handlePaymentShow();
                        setIsLoading(false);
                    }
                })
                .catch((error) => {
                    console.log({ error });
                    if (error.response.status === 402) {
                        handleClose();
                        handlePaymentShow();
                        setIsLoading(false);
                    } else {
                        addToast("Unable to follow user", {
                            appearance: "error",
                            autoDismiss: true,
                        });
                    }
                    setIsLoading(false);
                });
        }
    };

    const [errors, setErrors] = useState({});
    const [showError, setShowError] = useState(false);

    useEffect(() => {
        if (errors && Object.keys(errors).length > 0) {
            setShowError(true);
        } else {
            setShowError(false);
        }
    }, [errors]);

    const cancelToken = axios.CancelToken;
    const source = cancelToken.source();
    const processPayment = async (bySubscription = false) => {
        setIsLoading(true);
        dispatch(setProcessingFollow(true));
        let payload = {
            user_id: user.id,
            free_subscription:
                !bySubscription &&
                (!promoUrl || Object.keys(promoUrl).length == 0),
            by_subscription: bySubscription,
        };

        if (discountData && Object.keys(discountData).length > 0) {
            payload.is_discounted = 1;
            payload.link_url = discountData.link_url;
        } else {
            if (promoUrl && Object.keys(promoUrl).length > 0) {
                payload.link = promoUrl.link;
            }

            if (promoUrl.is_free_link) {
                payload.is_free_link = promoUrl.is_free_link;
            }

            if (promoUrl.link_price && promoUrl.link_url) {
                payload.is_discounted = 1;
            }
        }

        await axios
            .post("/api/transactions", {
                ...payload,
            })
            .then((response) => {
                setIsLoading(false);
                dispatch(setProcessingFollow(false));

                // 3DS handler
                if (!response.data.success && response.data.url) {
                    window.location = response.data.url;
                    return;
                }

                // handler for free trial links
                if (
                    !response.data.status &&
                    !response.data.url &&
                    response.data.message &&
                    !response.data.hasOwnProperty("success")
                ) {
                    dispatch(
                        setAlert({
                            show: true,
                            type: "error",
                            body: response.data.message,
                            onClose: () => window.location.reload(),
                        })
                    );
                    return;
                }

                handleClose();
                getUserInformation();
                setFollowStatus(true);

                // show paid subscription modal
                if (!bySubscription && !isTrialLink) {
                    setShowPaid(true);
                }

                if (bySubscription || (!bySubscription && isTrialLink)) {
                    setShowPaid(false);

                    if (
                        selectedPostGallery &&
                        Object.keys(selectedPostGallery).length > 0
                    ) {
                        dispatch(
                            setPostThankyou({
                                show: true,
                                pu: selectedPostGallery.user,
                                upgrade: true,
                            })
                        );
                    } else {
                        setShowThankYou(true);
                    }

                    if (
                        posts &&
                        posts.length > 0 &&
                        selectedPostGallery &&
                        Object.keys(selectedPostGallery).length === 0
                    ) {
                        const requireSubscriptionPostIds = posts
                            .filter((p) =>
                                postTypeNeedsSubscription(p.post_type)
                            )
                            .map((p) => p.id);
                        dispatch(
                            fetchPosts({
                                post_ids: requireSubscriptionPostIds,
                                user: user.login,
                                source,
                            })
                        );
                    }

                    // post media gallery subscription
                    if (
                        selectedPostGallery &&
                        Object.keys(selectedPostGallery).length > 0
                    ) {
                        window.dispatchEvent(
                            new CustomEvent("media-contents/subscription", {
                                detail: {
                                    post: selectedPostGallery,
                                },
                            })
                        );
                    }
                }

                localStorage.removeItem("promo_url");
                // setShowPaid(false);
                setFreeSubscription(false);
                setPromoUrl({});
                setFees({});
                setIsTrialLink(false);
                setIsTrialOrFree(false);
                setCardAdded(false);
                setLast4("");
                setHasExistingCard(false);
            })

            .catch((error) => {
                console.error({ error });
                setIsLoading(false);
                dispatch(setProcessingFollow(false));
                // captureException(error);
                let message =
                    "Unable to follow user. Please contact your bank.";
                let tmp = {};

                if (error.response) {
                    if (error.response.status === 503) {
                        let defaultMessage =
                            'There is an error processing the payment, please contact support <a href="https://priva.uvdesk.com/en/" target="_blank">here</a>.';

                        if (error.response.data.message) {
                            defaultMessage = error.response.data.message;
                        }

                        dispatch(
                            setAlert({
                                show: true,
                                type: "error",
                                body:
                                    error.response.data.message ||
                                    defaultMessage,
                                size: "md",
                            })
                        );
                    }

                    if (error.response.status == 400) {
                        message = error.response.data.message;
                    }

                    if (error.response.status == 422) {
                        Object.keys(error.response.data.errors).forEach(
                            (key) => {
                                tmp[key] = error.response.data.errors[key][0];
                            }
                        );
                        if (tmp.action_url) {
                            setRedirectUrl(tmp.action_url);
                            setTitle("Transaction Incomplete");
                        }
                        setErrors(tmp);
                        return;
                    } else if (error.response.status == 402) {
                        if (
                            error.response.data.error &&
                            error.response.data.error ===
                                CARD_ERRORS.NEEDS_VALIDATION
                        ) {
                            // setShowVerifyModal(true);
                            dispatch(
                                updateCcVerification({
                                    showVerify: true,
                                })
                            );
                            setShowModal(false);
                            return;
                        } else if (
                            error.response.data.error &&
                            error.response.data.error === CARD_ERRORS.NO_CARD
                        ) {
                            handlePaymentShow();
                            return;
                        } else {
                            handlePaymentShow();
                            tmp["transaction"] = error.response.data.reason;
                            setErrors(tmp);
                            return;
                        }
                    }

                    if (error.response.status == 404) {
                        localStorage.removeItem("promo_url");
                        dispatch(
                            setAlert({
                                show: true,
                                body:
                                    error.response.data.message ||
                                    "Discount link has already expired",
                                type: "error",
                                onClose: () => {
                                    window.location.reload();
                                },
                            })
                        );

                        return;
                    }

                    handlePaymentShow();
                }

                dispatch(
                    setAlert({
                        show: true,
                        title: "",
                        body: message,
                        type: "error",
                    })
                );
            });
    };

    let form = (
        <PSignupForm
            setSignupFormStatus={setSignupFormStatus}
            setShow={setShow}
        />
    );

    if (show === "login" && !isLoggedIn) {
        form = (
            <PLoginForm setShow={setShow} setReverifyData={setReverifyData} />
        );
    }

    if (show === "signup" && !isLoggedIn) {
        form = (
            <PSignupForm
                setSignupFormStatus={setSignupFormStatus}
                setShow={setShow}
            />
        );
    }

    if (show === "reverify" && !isLoggedIn) {
        form = (
            <PReverifyForm
                setShow={setShow}
                reverifyData={reverifyData}
                setReverifyData={setReverifyData}
            />
        );
    }

    if (show === "follow" || isLoggedIn) {
        form = (
            <div className="signup__follow mt-1">
                <Button
                    type="button"
                    disabled={isLoading}
                    onClick={(e) => handleFollow(e, !isTrialOrFree)}
                    className="btn theme-btn theme-btn-bordered btn-follow text-uppercase my-5"
                >
                    {!isTrialOrFree ? (
                        <>{isLoading ? "PROCESSING..." : "SUBSCRIBE"}</>
                    ) : (
                        <>{isLoading ? "PROCESSING..." : "FOLLOW FOR FREE"}</>
                    )}
                </Button>
                {!isTrialOrFree ? (
                    <>
                        {fees.fees && !!fees.reg_gst && fees.gst > 0 ? (
                            <p>
                                *{currency(fees.fees).format({ precision: 2 })}{" "}
                                processing fee plus{" "}
                                {currency(fees.gst).format({ precision: 2 })}{" "}
                                GST will apply.
                            </p>
                        ) : fees.fees > 0 ? (
                            <p>
                                *{currency(fees.fees).format({ precision: 2 })}{" "}
                                processing fee will apply.
                            </p>
                        ) : (
                            ""
                        )}
                    </>
                ) : null}

                {(isFree ||
                    (promoUrl &&
                        promoUrl.hasOwnProperty("is_free_link") &&
                        promoUrl.is_free_link) ||
                    (promoUrl && Object.keys(promoUrl).length > 0) ||
                    discountData ||
                    (user.creator &&
                        Object.keys(user.creator.promo_details).length > 0)) &&
                // checks for free plan subscription
                freeSubscription &&
                inFreeTiers(user.follow_tier) &&
                notExpired(user.subscription_status) ? (
                    <RenewalDetails user={user} />
                ) : null}

                {!isCheckingCard &&
                (!freeSubscription ||
                    (notExpired(user.subscription_status) &&
                        inFreeTiers(user.follow_tier))) ? (
                    <p>
                        {hasExistingCard
                            ? `Clicking follow will charge your existing credit card ending in ${last4} to finalise your subscription.`
                            : `Clicking "${
                                  !freeSubscription ||
                                  (freeSubscription &&
                                      inFreeTiers(user.follow_tier) &&
                                      notExpired(user.subscription_status))
                                      ? "Subscribe"
                                      : "Follow"
                              }" will take you to the payment screen to finalise your subscription.`}
                    </p>
                ) : null}
            </div>
        );
    }

    const checkUserHasCard = async () => {
        setIsCheckingCard(true);
        await axios
            .get("/api/transactions/check")
            .then((response) => {
                if (response.data.success && response.data.last4) {
                    setHasExistingCard(true);
                    setLast4(response.data.last4);
                }
                setIsCheckingCard(false);
            })
            .catch((error) => {
                setIsCheckingCard(false);
            });
    };

    useLayoutEffect(() => {
        $(".cover-photo").css({
            height: parseInt($(".cover-photo").width() / 2),
        });

        if (!showModal) {
            document.body.style.overflow = "auto";
        }
    }, [showModal]);

    const handleLogin = (e) => {
        e.preventDefault();
        const activeForm = show == "login" ? "signup" : "login";
        setShow(activeForm);
        localStorage.setItem("intended", user.login);
        // history.push('/login');
    };

    const RenderPrice = () => {
        if (isTrialLink && promoUrl && Object.keys(promoUrl).length > 0) {
            return <span> for {promoUrl.trial_period}</span>;
        }

        if (isTrialOrFree) {
            return null;
        }

        if (promoUrl && Object.keys(promoUrl).length > 0) {
            return (
                <>
                    <span className="text-blue">
                        {currency(promoUrl.link_price).format({ precision: 2 })}
                        *
                    </span>{" "}
                    for the first month
                </>
            );
        }

        if (discountData) {
            return (
                <>
                    <span className="text-blue">
                        {currency(discountData.link_price).format({
                            precision: 2,
                        })}
                        *
                    </span>{" "}
                    for the first month
                </>
            );
        }

        if (
            user.creator &&
            Object.keys(user.creator.promo_details).length > 0
        ) {
            return (
                <>
                    <span className="text-blue">
                        {currency(
                            user.creator.promo_details.promo_price
                        ).format({ precision: 2 })}
                        *
                    </span>{" "}
                    for the first month
                </>
            );
        }

        return (
            <>
                <span className="text-blue">
                    {currency(user.creator.subscription_price).format({
                        precision: 2,
                    })}
                    *
                </span>{" "}
                USD/month
            </>
        );
    };

    const SubscribeTo = () => {
        if (isTrialOrFree) {
            return (
                <>
                    Follow for free to{" "}
                    <span className="text-blue">@{user.login}</span>
                </>
            );
        }

        return (
            <>
                Subscribe to <span className="text-blue">@{user.login}</span>{" "}
            </>
        );
    };

    useEffect(() => {
        if (cardAdded) {
            setShowModal(true);
            setCardAdded(false);
        }
    }, [cardAdded]);

    const handleHidePaidOffer = () => {
        setShowPaid(false);
        document.body.style.overflow = "auto";
        handleClose();
    };

    useEffect(() => {
        if (showPaid) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }, [showPaid]);

    const handleHide = () => {
        if (!isLoading) {
            handleClose();
            setIsLoading(false);
        }
    };

    return (
        <>
            {Object.keys(user).length > 0 || showThankYou ? (
                <PThankYou
                    show={showThankYou}
                    pu={user}
                    setShow={setShowThankYou}
                />
            ) : (
                ""
            )}
            <Modal
                className={`modalSignUpFollow${
                    isThemeBlk ? " modalSignUpFollow__themeBlk" : ""
                }${
                    isThemeBlk && show === "login"
                        ? " modalSignUpFollow__themeBlk-login"
                        : ""
                }`}
                show={showModal && !showCreditCardForm}
                onHide={handleHide}
                size="lg"
                centered
            >
                <Modal.Body>
                    <CloseButton
                        className="close"
                        onClick={handleHide}
                        style={{
                            position: "absolute",
                            top: "12px",
                            right: "12px",
                        }}
                    />
                    <Row>
                        <Col xs={12} md={5} className="text-center pu">
                            <div
                                className={`cover-photo${
                                    user.cover_pic ? "" : " cover-photo-none"
                                }`}
                                style={{
                                    backgroundImage: `url(${s3Link}/${
                                        user.id
                                    }/cover_photo.jpg?t=${
                                        user.cover_photo_updated_at
                                            ? user.cover_photo_updated_at
                                            : new Date().valueOf()
                                    })`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center center",
                                    width: "100%",
                                }}
                            ></div>
                            <Avatar pu={user} story={false} size="100" />
                            {!isThemeBlk && (
                                <p className="text-blue">
                                    @{user.login}{" "}
                                    <LazyLoadImage
                                        src="/images/tick_small_edit.png"
                                        width="22"
                                        className="ml-1"
                                        style={{ marginBottom: "7px" }}
                                    />
                                </p>
                            )}
                        </Col>
                        <Col xs={12} md={7} className="signup">
                            {show === "follow" || show === "signup" ? (
                                <div className="signup__header">
                                    <SubscribeTo />
                                    <RenderPrice />
                                </div>
                            ) : null}

                            {show === "reverify" ? (
                                <div
                                    className={`reverify-message signup__details${
                                        isThemeBlk
                                            ? " signup__details-themeblk"
                                            : ""
                                    }`}
                                >
                                    <p>
                                        As part of our ongoing security measures
                                        we require you to verify your email
                                        address. You may keep your current email
                                        or update it.
                                    </p>
                                </div>
                            ) : (
                                <div
                                    className={`signup__details${
                                        isThemeBlk
                                            ? " signup__details-themeblk"
                                            : ""
                                    }`}
                                >
                                    <div className="signup__details__container">
                                        <ul>
                                            <li>
                                                Full Access to this creator's
                                                exclusive
                                                {isTrialOrFree
                                                    ? " free"
                                                    : ""}{" "}
                                                content{" "}
                                            </li>
                                            <li>
                                                Direct message with this creator{" "}
                                            </li>
                                            <li>
                                                Request personalised Pay Per
                                                View content
                                            </li>
                                            {isTrialOrFree ? (
                                                <li>Unfollow anytime</li>
                                            ) : (
                                                <li>
                                                    Cancel your subscription at
                                                    any time
                                                </li>
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            )}

                            <div
                                className="pu-form-modal"
                                style={{
                                    paddingLeft: "10px",
                                    paddingRight: "10px",
                                }}
                            >
                                {show != "follow" ? (
                                    <GoogleReCaptchaProvider
                                        language="en"
                                        useRecaptchaNet="true"
                                        reCaptchaKey={RECAPTCHA_SITE_KEY}
                                        scriptProps={{
                                            defer: true, // optional, default to false
                                            appendTo: "body", // optional, default to "head", can be "head" or "body",
                                        }}
                                    >
                                        <div
                                            className={`${
                                                show == "login"
                                                    ? "page-login"
                                                    : ""
                                            }`}
                                            style={{ backgroundColor: "unset" }}
                                        >
                                            {form}
                                        </div>
                                    </GoogleReCaptchaProvider>
                                ) : (
                                    <div style={{ backgroundColor: "unset" }}>
                                        {form}
                                    </div>
                                )}
                            </div>

                            {!isLoggedIn && show == "signup" && (
                                <p align="center">
                                    Already have an account? Click{" "}
                                    <a href="#" onClick={handleLogin}>
                                        here.
                                    </a>
                                </p>
                            )}

                            {!isLoggedIn && show == "login" && (
                                <p align="center">
                                    Don't have an account? Click{" "}
                                    <a href="#" onClick={handleLogin}>
                                        here.
                                    </a>
                                </p>
                            )}
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>

            {/* Pre transaction error */}
            {errors.transaction ? (
                <PAlert
                    show={showError}
                    setShow={setShowError}
                    title={title}
                    body={errors.transaction}
                    onClose={() => {
                        if (redirectUrl) {
                            window.location.href = redirectUrl;
                        }
                    }}
                />
            ) : null}

            {showPaid ? (
                <PaidSubscriptionOffer
                    show={showPaid}
                    setShow={setShowPaid}
                    handleClose={handleHidePaidOffer}
                    handleFollow={handleFollow}
                    isLoading={isLoading}
                    pu={user}
                />
            ) : null}
        </>
    );
};

const mapStateToProps = (state) => ({
    showCreditCardForm: state.privaGlobal.creditCardForm.show,
    posts: state.post.posts,
    selectedPostGallery: state.post.selectedPostGallery,
});

export default connect(mapStateToProps)(PSignupModal);
